import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-modal-payment-installment',
  templateUrl: './modal-payment-installment.component.html',
  styleUrls: ['./modal-payment-installment.component.scss']
})
export class ModalPaymentInstallmentComponent implements OnInit {
  public paymentName: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.paymentName = this.data.payment;
  }
}
